import { fetcher, put } from '../../../services/api';
import type { OrderItem } from '../context/MorningDashboardContextProps';

export type LayoutApiItem = { key: string; order: number };
const layoutApi = '/api/v1/morning-view/layout';

export const widgetOrderService = {
    getLayout: async (): Promise<OrderItem[]> => {
        const data = await fetcher<LayoutApiItem[]>(layoutApi);
        return data.map((item) => ({ key: item.key as OrderItem['key'], order: item.order }));
    },

    updateLayout: async (items: OrderItem[]): Promise<void> => {
        const payload: LayoutApiItem[] = items.map((item, index) => ({ key: item.key, order: index + 1 }));
        await put(layoutApi, payload);
    },
};
